import { inject } from '@angular/core';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';

import { translatedObjectSignal } from '@advania-cosoftware/wolf-core';

import { VersionUpdateDialogComponent } from './components/version-update-dialog/version-update-dialog.component';
import {
    VersionUpdateDialogText,
    versionUpdateDialogTextKey,
} from './components/version-update-dialog/version-update-dialog.translations';

export function createVersioningConfig(acceptUpdate: () => Promise<boolean>) {
    const dialogService = inject(DialogService);
    const text = translatedObjectSignal<VersionUpdateDialogText>(versionUpdateDialogTextKey);
    let versionDialogRef: DynamicDialogRef<VersionUpdateDialogComponent> | null = null;

    const openVersionDialog = () => {
        if (versionDialogRef !== null) {
            return;
        }

        const handleUpdateNow = async (): Promise<boolean> => {
            const didUpdate = await acceptUpdate();

            if (!didUpdate) {
                return false;
            }

            versionDialogRef?.close();

            return true;
        };

        const dialogRef = dialogService.open(VersionUpdateDialogComponent, {
            header: text().Title,
            width: '22rem',
            modal: true,
            closable: false,
            dismissableMask: false,
            draggable: false,
            resizable: false,
            pt: {
                header: {
                    class: 'justify-center',
                },
                title: {
                    class: 'w-full text-center',
                },
            },
            breakpoints: {
                '960px': '90vw',
                '640px': '95vw',
            },
            data: {
                onUpdateNow: handleUpdateNow,
                onReloadPage: () => window.location.reload(),
            },
        });

        versionDialogRef = dialogRef;

        dialogRef?.onClose.subscribe(() => {
            versionDialogRef = null;
        });
    };

    return {
        onUpdateRequired: () => {
            openVersionDialog();
        },
        onUpdateNow: () => window.location.reload(),
    };
}
